import React from 'react'
import PropTypes from 'prop-types'
import MutationManager from './Mutation'
import gql from 'graphql-tag'

// example payload
// {
//   "id": "group-id"
// }
//

const CREATE_GROUP = gql`mutation deleteGroup($id: String) {
  deleteGroup(id: $id) {
    id
  }
}
`
const UpdatePickers = ({ children, ...props }) => {
  return (
    <MutationManager mutation={CREATE_GROUP} refetchQueries={['getGroups', 'getUserSessionInfo']}>
      {({ data, loading, updateFn }) => children({ deleteFn: updateFn, loading, ...props })}
    </MutationManager>
  )
}

UpdatePickers.propTypes = {
  children: PropTypes.any
}

export default UpdatePickers
